const state = {
    marketingcampaign: [],
    marketingcampaignid: {},
    loading: false,
};

export default state;